export interface DeveloperOverlayState {
  worldDebug: boolean;
  chunks: boolean;
  colliders: boolean;
  poi: boolean;
  biomeColors: boolean;
  biomeBoundaries: boolean;
  roads: boolean;
  rivers: boolean;
  serverInterest: boolean;
  interaction: boolean;
}

export const DEFAULT_DEVELOPER_OVERLAYS: DeveloperOverlayState = Object.freeze({
  worldDebug: false,
  chunks: false,
  colliders: false,
  poi: false,
  biomeColors: false,
  biomeBoundaries: false,
  roads: false,
  rivers: false,
  serverInterest: false,
  interaction: false,
});

export interface DeveloperEvent {
  readonly at: number;
  readonly message: string;
}

export class LocalDeveloperState {
  panelOpen = false;
  screenshotMode = false;
  overlays: DeveloperOverlayState = { ...DEFAULT_DEVELOPER_OVERLAYS };
  readonly events: DeveloperEvent[] = [];

  log(message: string): void {
    this.events.push({ at: Date.now(), message });
    if (this.events.length > 75) this.events.splice(0, this.events.length - 75);
  }

  setOverlay<K extends keyof DeveloperOverlayState>(name: K, enabled: DeveloperOverlayState[K]): void {
    this.overlays = { ...this.overlays, [name]: enabled };
    if (name !== "worldDebug" && enabled) this.overlays.worldDebug = true;
  }

  reset(): void {
    this.screenshotMode = false;
    this.overlays = { ...DEFAULT_DEVELOPER_OVERLAYS };
    this.log("DEV state reset");
  }
}
